/** 
 * Informações das colunas para lista
 * @type {Array<{
 *   label: string,
 *   name: string,
 *   width: string | number,
 *   colSpan: string | number,
 *   className: string,
 *   style: string
 * }>} 
*/
export const columns = [
    {
        label: 'Sigla',
        name: 'sigla',
        width: '20%',
        // className: 'd-none d-md-block w-auto',
    },
    {
        label: 'Nome',
        name: 'nome',
        // width: '20%',
    },
    {
        label: 'Valor',
        name: 'valor',
        className: 'text-right',
        // width: '20%',
    },
];


const BeneficioColabListInfo = { columns };

export default BeneficioColabListInfo;
